module.exports = __webpack_public_path__ + "img/style_1_topbg_yd.07d9c36d.webp";